<template>
  <div class='slide slide-fullscreen'>
    <h2 class='slide-fullscreen_title'>
      {{ label }}
    </h2>

    <blockquote class='slide-fullscreen_headline h-two-light'>
      {{ activity.headline }}
    </blockquote>

    <div class='slide-fullscreen_subheadline body-four-light'>
      {{ activity.subheadline }}
    </div>
  </div>
</template>

<script>
import CommonMixin from './common-mixin'

export default {
  mixins: [CommonMixin],

  computed: {
    label() {
      return this.activity.label || this.$t('quote')
    }
  }
}
</script>

<style lang='sass' scoped>
@import './fullscreen-v1'
</style>
